import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrescriptionSettingComponent } from 'app/EMR/prescription-setting/prescription-setting.component';
import { EMRService } from 'app/EMR/EMR.service';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
@Component({
  selector: 'app-opd-setting',
  templateUrl: './opd-setting.component.html',
  styleUrls: ['./opd-setting.component.scss']
})
export class OpdSettingComponent implements OnInit {
 Selected = 'Prescription';
  prescriptionSetting: any;

  PrintList: any;
  selectReportValue: any;

  constructor(public dialog: MatDialog, public emrservice: EMRService,public authservice:AuthService ,public dialogRef: MatDialogRef<OpdSettingComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,public dashboardService: DashboardService) { }

  ngOnInit(): void {
   
    this.selectReportValue='Prescription';
    if(this.data !=undefined){
      this.PrintList =this.data;
    }else{
      this.getpreSetting(this.authservice.Loggeduser.branchid, this.authservice.Loggeduser.userid,this.selectReportValue);
    }
   
  }
 

 
  selectValue(value){
       
        console.log(value)
    this.selectReportValue='Prescription';
  
  }
  pre_setting(): void {

    const dialogRef = this.dialog.open(PrescriptionSettingComponent, {

      panelClass: 'full-width-dialog',
      maxWidth: '80vw',
      width: '50%',
      data: this.selectReportValue,
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getpreSetting(this.authservice.Loggeduser.branchid, this.authservice.Loggeduser.userid,this.selectReportValue);
    
    });

  }

 
  getpreSetting(bachid ,userid,data) {
  
    this.emrservice.GetPreSetting(bachid,userid,data).subscribe(data => {
      this.prescriptionSetting =[];
          this.prescriptionSetting = data;
     this.PrintList = this.prescriptionSetting.filter( x => !x.colName.startsWith("Clear") );
     if(this.prescriptionSetting.length ==0){
         this.defaultdataCheck(data);
     } 
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  defaultdataCheck(data){
    this.emrservice.GetPreSetting(1,1,this.selectReportValue).subscribe(data => {
      this.prescriptionSetting = data;
this.PrintList = this.prescriptionSetting.filter( x => !x.colName.startsWith("Clear") );

});
  }
  PrintClick(clickedItem: number) {
    this.PrintList[clickedItem].colValue = !this.PrintList[clickedItem].colValue  
   }
   closedialog(){
    this.dialogRef.close(this.PrintList);
  }
}
